import React, { useEffect, useState, useRef } from 'react';
import * as XLSX from 'xlsx';
import { MwButton, MwInputText, MwSelector, MwSpinner, MwSpinnerButton, NoDataFound } from '../ui';
import { useTranslation } from 'react-i18next';
import { useCurrent, useFetch } from '../../hooks';
import MwCardWrapper from '../ui/MwCardWrapper';
import { printableDiv } from '../../utils/global';
import { FaRegFileExcel, FaPrint, FaFilePdf } from "react-icons/fa";
import handleConvertToPDF from '../../utils/handleConvertToPDF';
import MwSelectorProduct from '../ui/MwSelectorProduct';
import RequisitionsReportsList from './RequisitionsReportsList';
import RequisitionsReportsTable from './ProductReportsList';
  const ProductReports = () => {
  const divPrintRef = useRef();
  const [t, i18n] = useTranslation('global');
  const { currentLangId, currentTenantId, currentCompanyId, currentBranchId } = useCurrent();
  const isRTL = i18n.dir() === 'rtl';

  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1).toLocaleDateString('en-CA');
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0).toLocaleDateString('en-CA');

  const [formStates, setFormStates] = useState({
    startDate: firstDay,
    endDate: lastDay,
  });
  const [fromWarehouse, setFromWarehouse] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [reportUrl, setReportUrl] = useState(null);
  const [isPrintMode, setIsPrintMode] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Fetch warehouses data
  const warehousesUrl = `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses/${currentTenantId}/${currentCompanyId}/${currentBranchId}`;
  const { data: warehousesData } = useFetch(warehousesUrl);
  
  // Fetch report data
  const { data: reportData, loading: reportLoading, fetchData: fetchReport } = useFetch(reportUrl, false);
  
  const [warehouses, setWarehouses] = useState([]);

  useEffect(() => {
    if (warehousesData?.data) {
      const formatted = warehousesData.data.map((warehouse) => ({
        _id: warehouse.id,
        label: warehouse.name_ar || warehouse.name,
      }));
      setWarehouses([{ _id: "", label: t("reports.All") }, ...formatted]);
    }
  }, [warehousesData, t]);

  // Reset isSubmitting when report loading is done
  useEffect(() => {
    if (!reportLoading) {
      setIsSubmitting(false);
    }
  }, [reportLoading]);

  useEffect(() => {
    if (reportUrl) {
      fetchReport();
    }
  }, [reportUrl]);

  const submitHandler =   (e) => {
    e.preventDefault();
    if (!formStates.startDate || !formStates.endDate) return;

    setIsSubmitting(true);
    const warehouseParam = fromWarehouse === "" ? "0" : fromWarehouse;
    const productParam = selectedProduct?._id|| "0";

    const endpoint = `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses/items/product/${currentTenantId}/${currentCompanyId}/${currentBranchId}/${warehouseParam}/${productParam}/${formStates.startDate}/${formStates.endDate}`;
        
    setReportUrl(null);
    setTimeout(() => {
      setReportUrl(endpoint);
    }, 0); 
    console.log("endpoint" ,endpoint);
    
  };

  const printHandler = () => {
    setIsPrintMode(true);
    setTimeout(() => {
      printableDiv(divPrintRef, currentLangId);
      setTimeout(() => {
        setIsPrintMode(false);
      }, 1000);
    }, 100);
  };

  const pdfHandler = () => {
    setIsPrintMode(true);
    setTimeout(() => {
      handleConvertToPDF({
        lang: 'ar',
        elementId: 'printableDiv',
        fileName: `تقرير_الأذونات.pdf`
      });
      setTimeout(() => {
        setIsPrintMode(false);
      }, 1000);
    }, 100);
  };

  const exportExcel = () => {
    if (reportData?.data?.length > 0) {
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(reportData.data);
      XLSX.utils.book_append_sheet(wb, ws, t("reports.product_Report"));
      XLSX.writeFile(wb, `${t("reports.product_Report")}.xlsx`);
    }
  };

  return (
    <div className="text-[#251658] h-[calc(100vh-50px)] custom-scrollbar p-2">
      <div id="header">
        <p className="pb-3 text-sm">{t("reports.product_Report")}</p>
      </div>

      <MwCardWrapper>
        <form onSubmit={submitHandler} className="flex flex-col gap-5 p-5">
          <div className="grid grid-cols-4 gap-5">
            <div className="w-full">
              <label className="block text-start text-[#251658] mb-2 text-xs">
                {t("reports.Date_From")}
              </label>
              <div className="flex items-center">
                <MwInputText
                  inputType="date"
                  className="flex-grow"
                  value={formStates.startDate}
                  onChange={(e) =>
                    setFormStates({ ...formStates, startDate: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="w-full">
              <label className="block text-start text-[#251658] mb-2 text-xs">
                {t("reports.Date_To")}
              </label>
              <div className="flex items-center">
                <MwInputText
                  inputType="date"
                  className="flex-grow"
                  value={formStates.endDate}
                  onChange={(e) =>
                    setFormStates({ ...formStates, endDate: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="w-full">
              <label className="block text-start text-[#251658] mb-2 text-xs">
                {t("reports.Choose_Warehouse")}
              </label>
              <MwSelector
                label=""
                _data={warehouses}
                dataType="labelValue"
                initalValue={t("reports.Choose_Warehouse")}
                selectedItem={warehouses.find((w) => w._id === fromWarehouse)}
                setSelectedItem={(item) => {
                  console.log("item" , item)
                  setFromWarehouse(item._id);
                }}
                withSearch={false}
                withLabel={false}
                className="w-full text-center"
              />
            </div>

            <div className="w-full">
              <label className="block text-start text-[#251658] mb-2 text-xs">
                {t("reports.Choose_Product")}
              </label>
              <MwSelectorProduct
              showSearchInList={false}
                onChangeCallback={setSelectedProduct}
                withLabel={false}
                value={selectedProduct?.productName || ""}
                initalValue={selectedProduct?.productName || ""}
                disabled={false}
                inputStyle={{
                  textAlign: 'center',
                }}
              
              />
            </div>
          </div>

          <div className="pt-3 flex justify-end">
            {!isSubmitting ? (
              <MwButton type="saveBtn" disabled={!formStates.startDate || !formStates.endDate  || !selectedProduct}>
                {t("reports.Prepare_Report")}
              </MwButton>
            ) : (
              <MwSpinnerButton />
            )}
          </div>
        </form>
      </MwCardWrapper>

      {reportUrl && (
  <MwCardWrapper id="Result">
    {reportLoading ? (
        // <MwSpinner />
        <NoDataFound msg={t("reports.No_Results")} />
  
    ) : (
      reportData && reportData.data && reportData.data.length > 0 ? (
        <div className="w-full">
          <div className="flex justify-between">
            <div className="px-2 text-[#251658]"></div>
            <div className="p-3 text-[#251658]">
              <ul className="flex gap-1">
                <li
                  style={{ cursor: "pointer" }}
                  onClick={exportExcel}
                  className="px-2 py-1 flex items-center gap-1 bg-white border border-gray-200 hover:border-[#251658] hover:font-bold"
                >
                  <FaRegFileExcel />
                  <span className="text-sm text-[#251658]">{t("reports.Export_Excel")}</span>
                </li>
                <li
                  style={{ cursor: "pointer" }}
                  onClick={pdfHandler}
                  className="px-2 py-1 flex items-center gap-1 bg-white border border-gray-200 hover:border-[#251658] hover:font-bold"
                >
                  <FaFilePdf />
                  <span className="text-sm text-[#251658]">{t("reports.Save_as_PDF")}</span>
                </li>
                <li
                  style={{ cursor: "pointer" }}
                  onClick={printHandler}
                  className="px-2 py-1 flex items-center gap-1 bg-white border border-gray-200 hover:border-[#251658] hover:font-bold"
                >
                  <FaPrint />
                  <span className="text-sm text-[#251658]">{t("reports.Print")}</span>
                </li>
              </ul>
            </div>
          </div>
          <div
            id="printableDiv"
            ref={divPrintRef}
            className={`text-[#251658] ${isPrintMode ? "" : "h-[calc(100vh-100px)] overflow-y-scroll custom-scrollbar"}`}
          >
            <div className="text-[#251658] text-center">
              <div className="font-bold">{t("reports.product_Report_for_Period")}</div>
              <div className="font-medium">
                <span>{t("reports.From")} {formStates.startDate}</span>
                <span className="mx-2">{t("reports.To")} {formStates.endDate}</span>
              </div>
            </div>
            {reportData.data && (
              <RequisitionsReportsTable reportData={reportData} warehouses={warehouses} />
            )}
          </div>
        </div>
      ) : (
        <NoDataFound msg={t("reports.No_Results")} />
      )
    )}
  </MwCardWrapper>
)}

    </div>
  );
};

export default ProductReports;


